import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

export const Header = styled.h2<{ $isSent?: boolean }>`
  ${font('headline-md')};
  ${({ $isSent }) => ($isSent ? 'auto' : '0')};
  margin: 1rem 0 2rem;
  padding: 0;
  text-align: center;
  @media screen and (${query.below('tablet')}) {
    font-size: 32px;
  }
`;

export const Text = styled.div`
  color: ${color('fg')};
  ${font('body-md-light')};
  text-align: center;
  @media screen and (${query.below('tablet')}) {
    ${font('body-sm-light')};
  }
`;

export const DesktopHeader = styled.div`
  max-width: 41rem;
`;

export const MarketReportName = styled.div`
  color: ${color('cta')};
  font-size: 0.88rem;
  line-height: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.13rem;
  text-align: center;
`;

export const MarketReportDescriptionContainer = styled.div`
  gap: 2rem;
  opacity: 0px;
  padding: 0 12.1rem 3rem 12.1rem;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 1200px) {
    padding: 0 6rem 1.5rem 6rem;
  }
  @media screen and (${query.below('desktop')}) {
    padding: 0 6rem 3rem 6rem;
    margin-left: 0;
    margin-right: auto;
    padding: 0;
  }
`;

export const Container = styled.div`
  align-items: center;
  gap: calc(${space('x10')} + ${space('md')});
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5rem;
  padding: ${space('x10')};
  padding-left: calc(${space('x10')} + ${space('md')});
  @media screen and (${query.below('tablet')}) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    padding: ${space('x10')} ${space('xl')};
  }
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;

  @media screen and (${query.below('desktop')}) {
    padding: ${space('xl')} ${space('x6')};
    margin-left: 0;
    margin-right: auto;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.13rem;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: ${space('x6')};
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ImageWrapper = styled.div`
  margin-right: 5rem;
  position: relative;
  width: 32.5rem;

  iframe {
    width: 100%;
    padding: 0;
    margin: 0;
    height: 100%;
    object-fit: cover;
    border: none;
  }

  @media (max-width: 1200px) {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  @media screen and (${query.below('desktop')}) {
    max-width: 300px;
    max-height: 450px;
  }

  @media (max-width: 650px) {
    max-width: 250px;
    max-height: 300px;
  }
`;

export const DisclaimerText = styled.div`
  color: ${color('gray4')};
  ${font('body-sm-light')};
  font-weight: 400;
  line-height: 1.5rem;
  align-self: start;
  margin-left: auto;
  margin-right: auto;
`;

export const DisclaimerAndButtonContaienr = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  max-width: 29.5rem;
  column-gap: 0.5rem;
`;

export const ReadMore = styled.div`
  color: ${color('gray4')};
  ${font('body-sm-light')};
  display: block;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 1rem;
  margin-top: 0;
`;

export const FieldWrapper = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  height: 4.3rem;
  padding-bottom: 0.5rem;
  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }
  margin-left: auto;
  margin-rigth: auto;
`;

export const StyledForm = styled.form<{ $gutterWidth?: boolean }>`
  display: flex;
  max-width: 30rem;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  gap: 1.5rem;

  @media screen and (${query.below('tablet')}) {
    gap: ${({ $gutterWidth }) => ($gutterWidth ? space('x6') : space('md'))};
    width: 100%;
    button {
      width: 100%;
    }
  }
`;

export const CustomButtonWrapper = styled.div`
  width: 100%;
  postion: relative;
  margin-right: auto;
  margin-left: auto;

  button {
    font-weight: 700;
  }
  @media screen and (${query.below('desktop')}) {
    button {
      border-radius: 0.25rem;
    }
  }
`;
